import { RemoteSourceRow } from 'components/tables/data/remote-source/types';
import P2Regular from 'components/typography/P2Regular';
import { useMemo } from 'react';

/**
 * Column for the remote source type.
 */
export default function TypeColumn({ data: { type } }: { data: RemoteSourceRow }) {
  const typePretty = useMemo(() => type.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()), [type]);
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {typePretty}
    </P2Regular>
  );
}
